/**
 * 前端配置管理工具的导出模块.
 *
 * 提供统一的配置管理接口，支持环境变量、全局变量等多种配置源。
 *
 * @packageDocumentation
 * @author yusangeng@outlook.com
 */
import konph from "./konph";
/**
 * 配置管理器的工厂函数
 *
 * @param config - 配置定义对象
 * @returns 配置管理器实例
 */
export { konph };
/**
 * 默认导出配置管理器的工厂函数
 */
export default konph;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7R0FPRztBQUVILE9BQU8sS0FBSyxNQUFNLFNBQVMsQ0FBQztBQVE1Qjs7Ozs7R0FLRztBQUNILE9BQU8sRUFBRSxLQUFLLEVBQUUsQ0FBQztBQUVqQjs7R0FFRztBQUNILGVBQWUsS0FBSyxDQUFDIn0=